import * as Yup from 'yup';

import { DebtTypes } from './debtTypes.types';

export const getValidationSchema = () => {
  return Yup.array<DebtTypes[]>().min(1).required();
};
